import { createSlice } from '@reduxjs/toolkit';
import { PortfolioItemResponse } from 'types/portfolios';
import { portfolioItems } from './portfolioApi';

interface PortfolioSliceState {
    items: PortfolioItemResponse[];
}

const initialState: PortfolioSliceState = {
    items: [],
};

export const portfolioSlice = createSlice({
    name: 'portfolio-slice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(portfolioItems.fulfilled, (state, action) => {
            state.items = action.payload;
        });
    },
});
